{
  "#PMS_ROSTER": {
    "TITLE": "Dienstplaner",
    "NO_DATA": "Keine Daten zum Anzeigen vorhanden"
  }
}
